import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Libraries
import { BrowserRouter } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import { LazyMotion, domMax } from "framer-motion";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify"; //  import
import "react-toastify/dist/ReactToastify.css"; //  css

// css
import "./Assets/css/icons.css";
import "./Assets/css/global.css";
import "./Assets/css/pages.css";
import "./index.scss";
import "./i18n";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import store from "./store";
import { AuthProvider } from "./Pages/meldi-dham-pages/auth-pages/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LazyMotion features={domMax}>
    <ParallaxProvider>
      <BrowserRouter>
        <Provider store={store}>
          <AuthProvider>
            {" "}
            {/*  wrap here */}
            <App />
          </AuthProvider>
          {/*  Global toast container */}
          <ToastContainer
            position="top-right"
            autoClose={2000}
            theme="colored"
          />
        </Provider>
      </BrowserRouter>
    </ParallaxProvider>
  </LazyMotion>
);
